module.exports = __webpack_public_path__ + "img/4-4.67e2dfad.svg";